/*LIBRARY*/
import { useState, useContext } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { create_bi } from "../../App/actions/biActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const CREATE_BI = ({ auth, create_bi, toggle_create_bi, post_activities }) => {
  //local state
  const [name, set_name] = useState("");

  const { handleError } = useContext(ErrorContext);

  const on_change = (e) => {
    handleError(() => {
      set_name(e.target.value);
    })();
  };

  const on_submit = (e) => {
    e.preventDefault();
    handleError(() => {
      const body = {
        name,
        folder_list: [],
        project_list: [],
        setting_list: [],
        card_list: [],
      };
      create_bi(body);
      toggle_create_bi();

      post_activities({
        action: "create_bi",
      });
    })();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props

  //content

  return (
    <main>
      <form onSubmit={on_submit}>
        <p className="margin_top margin_bottom">
          {dict?.["Enter BI name"]?.[language]}
        </p>
        <input
          name="name"
          value={name}
          onChange={on_change}
          type="text"
          className="margin_bottom"
          placeholder={dict?.["BI name"]?.[language]}
          data-mapid="inputBIName"
        />
        <br />
        <br />
        <button
          type="submit"
          className="button background_black"
          data-mapid="createBIDashboard"
        >
          {dict?.["Save"]?.[language]}
        </button>
      </form>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { create_bi, post_activities })(
  CREATE_BI,
);
